exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-blank-dialog-mod .col-input-small[data-v-66a349c8]{max-width:300px}.add-blank-dialog-mod .dialogForm-submit-row[data-v-66a349c8]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.add-blank-dialog-mod .dialogForm-submit-row .dialog-btn[data-v-66a349c8]{margin:0 10px}.add-blank-dialog-mod .col-autocomplete-input[data-v-66a349c8]{width:300px}", ""]);

// exports
